import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { apiClient } from '../../services/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/Card';
import { Button, Input, Label } from '@/components/ui/shadcn';

export default function ForgotPasswordContactPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const onGetOtp = async () => {
    if (!email.trim()) {
      toast.error('Please enter your email');
      return;
    }
    setLoading(true);
    try {
      const res = await apiClient.requestForgotPasswordOtp(email.trim());
      if (!res.success || !res.data?.token) {
        toast.error(res.message || 'Failed to send OTP');
        return;
      }
      toast.success('OTP sent successfully');
      navigate('/forgot-password/otp', {
        state: {
          requestToken: res.data.token,
          contact: email.trim(),
          nextResendAt: res.data.next_resend_at,
        },
      });
    } catch (error: unknown) {
      const msg =
        (error as { response?: { data?: { message?: string } } })?.response?.data?.message ||
        'Failed to send OTP';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md">
        <CardHeader>
          <p className="text-center text-xs font-medium uppercase tracking-wide text-muted-foreground">
            Step 1 of 3
          </p>
          <CardTitle className="text-center text-xl">Forgot Password</CardTitle>
          <CardDescription className="text-center">
            Enter the email address registered to your admin account.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
              className="mt-1"
            />
          </div>
          <Button type="button" className="w-full" onClick={onGetOtp} disabled={loading}>
            {loading ? 'Sending…' : 'Get OTP'}
          </Button>
          <Link to="/login" className="block text-center text-sm text-primary hover:underline">
            Back to Login
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
